import React, { Component } from 'react';
import { compose } from 'recompose';
import hasUserInfo from '../../hocs/has-user-info';
import hasJSONAPIClient from '../has-jsonapi-client';
import { reportError } from '../../utils/error-handling-service';
import {
  ORGANISATION_RESOURCE,
} from '../../utils/helpers/resources';

const hasOrganisation = WrapperComponent => class extends Component {
  constructor() {
    super();
    this.state = {
      organisationLoading: true,
      organisationError: false,
    };
  }

  componentDidMount = () => {
    const { userInfo, jsonAPIClient } = this.props;
    if (userInfo) {
      const { organisationId } = userInfo;
      jsonAPIClient.get(ORGANISATION_RESOURCE, organisationId).then(organisationResource => {
        const organisation = organisationResource.toJSON();
        return this.setState({ organisation, organisationLoading: false });
      })
        .catch(err => {
          reportError('Unknown error', err);
          return this.setState({ organisationError: false, organisationLoading: false });
        });
    }
  }

  render() {
    return <WrapperComponent {...this.props} {...this.state} />;
  }
};

export default compose(hasUserInfo, hasJSONAPIClient, hasOrganisation);



/** WEBPACK FOOTER **
 ** ./src/hocs/has-organisation/index.js
 **/